//src/app/features/dashboard/admin/stats/EngagementLetterStats.tsx
import Spinner from 'Components/Spinner';
import PieChartStats from './PieChartStats';
import { useGetEngagementLetterStatsQuery } from 'app/services/engagementLetters';

const COLORS = ['#39BE9D', '#DC3545'];

interface IEngagementLettersStats {
  year: number;
}

const EngagementLetterStats = ({ year }: IEngagementLettersStats) => {
  const { data } = useGetEngagementLetterStatsQuery({
    filters: {
      year,
    },
  });

  if (!data)
    return (
      <div className="h-48 flex justify-center items-center">
        <Spinner />
      </div>
    );

  return (
    <div className="flex-1">
      <div className="w-full flex-1 font-semibold px-4 pt-4  text-sm text-gray-dark">
        Number of Engagements ({data.engagement_letters_total_count})
      </div>

      <PieChartStats
        data={[
          {
            name: 'Signed',
            value: data.engagement_letters_signed_count,
          },
          {
            name: 'Unsigned',
            value: data.engagement_letters_unsigned_count,
          },
        ]}
        total={data.engagement_letters_total_count}
        colors={COLORS}
      />
    </div>
  );
};

export default EngagementLetterStats;
